import { AuthStep } from "../../types";
import { api } from "../Api/api";

/**
 * Interface para requisição de inicialização de autenticação de dispositivo
 */
export interface InitDeviceAuthRequest {
  /** Código do usuário para ativação do dispositivo */
  userCode: string;
}

/**
 * Interface para resposta de inicialização de autenticação de dispositivo
 */
export interface InitDeviceAuthResponse {
  /** ID da sessão criada para o dispositivo */
  sessionId: string;
  /** Próximo passo no fluxo de autenticação */
  nextStep: AuthStep;
}

/**
 * Interface para resposta de confirmação de autorização de dispositivo
 */
export interface DeviceAuthConfirmResponse {
  /** Mensagem de sucesso */
  message: string;
  /** Status da operação */
  status: string;
  /** Indica se o dispositivo foi autorizado */
  deviceAuthorized: boolean;
  /** Código do usuário */
  user_code: string;
}

/**
 * Inicializa o processo de autenticação de dispositivo
 * Valida o código do usuário e retorna informações da sessão
 * 
 * @param {InitDeviceAuthRequest} request - Dados da requisição contendo o código do usuário
 * @returns {Promise<InitDeviceAuthResponse>} Promise com dados da sessão e próximo passo
 * @throws {Error} Erro caso o código seja inválido ou expirado
 */
export const initDeviceAuth = async (
  request: InitDeviceAuthRequest
): Promise<InitDeviceAuthResponse> => {
  try {
    const response = await api.post<InitDeviceAuthResponse>(
      "/device-auth/init",
      {
        user_code: request.userCode,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Confirma a autorização de dispositivo
 * Esta função é chamada na última etapa do fluxo de autenticação com user code
 * em vez de redirecionar o usuário
 * 
 * @returns {Promise<DeviceAuthConfirmResponse>} Promise com resultado da confirmação
 * @throws {Error} Erro caso a confirmação falhe
 */
export const confirmDeviceAuthorization = async (): Promise<DeviceAuthConfirmResponse> => {
  try {
    const response = await api.post<DeviceAuthConfirmResponse>(
      "/device-auth/confirm-device-authorization"
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

